export default {
  InputEmpty: "कृपया {name} दर्ज करें"
} as const;
